import React, { useMemo } from 'react';
import { Listbox } from '@headlessui/react';
import ChevronDown from '../icon/chevron-down.svg';

export default function DropdownFilter({
  title,
  options,
  selected,
  setSelected,
}: {
  title: string;
  options: Array<string | { value: string; label: string }>;
  selected: string | null;
  setSelected: (s: string | null) => void;
}) {
  // clear selection:
  // const onChange = (s: string) => {
  //   s === selected ? setSelected(null) : setSelected(s);
  // };

  // If we have separate labels and values, we need to translate selection from value back to its matching label
  const selectedLabel = useMemo(() => {
    const found = options.find((o) =>
      typeof o === 'string' ? false : o.value === selected
    );
    return found === undefined || typeof found === 'string'
      ? selected
      : found.label;
  }, [selected, options]);

  return (
    <div className="sm:mx-1">
      <Listbox value={selected} onChange={setSelected}>
        <Listbox.Button className="sm:pl-2 text-left font-bold capitalize inline-flex">
          {selected ? selectedLabel : title}
          <ChevronDown className="fill-white w-5 h-6 mx-1" />
        </Listbox.Button>
        <Listbox.Options className="absolute mt-1 w-40 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          {options &&
            options.map((status) => (
              <Listbox.Option
                key={typeof status === 'string' ? status : status.value}
                value={typeof status === 'string' ? status : status.value}
                className="p-2 capitalize font-normal relative text-black bg-white cursor-pointer z-10"
              >
                {typeof status === 'string' ? status : status.label}
              </Listbox.Option>
            ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
}
